import React, { useState, useEffect } from 'react';
import { ErrorBox } from './common/ErrorBox';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { useFormContext } from 'react-hook-form';

const SingleDimensionPicker = ({
  name,
  label,
  title,
  errors,
  detailed_label,
  validation,
  field,
  defaultValue,
  displayUnit = null,
  conversionFactor = 1
}) => {
  const { register, setValue, getValues } = useFormContext();

  // Determine effective label (with display unit if applicable)
  const effectiveLabel = displayUnit
    ? field?.label?.replace(/\(.*?\)/, `(${displayUnit})`) || `${label} (${displayUnit})`
    : field?.label || label;

  // Convert backend value to display value
  const backendToDisplay = (value) => {
    if (!value) return '';
    return (parseFloat(value) / conversionFactor).toString();
  };

  // Convert display value to backend value
  const displayToBackend = (value) => {
    if (!value) return '';
    return (parseFloat(value) * conversionFactor).toString();
  };

  // Local state for display value
  const [displayValue, setDisplayValue] = useState(() => {
    const backendValue = getValues(name) || defaultValue || '';
    return backendToDisplay(backendValue);
  });

  // Handle input change
  const handleChange = (e) => {
    const newDisplayValue = e.target.value;
    setDisplayValue(newDisplayValue);

    // Convert to backend value and update form
    const backendValue = displayToBackend(newDisplayValue);
    setValue(name, backendValue, { shouldValidate: true });
  };

  return (
    <div className="bg-white/60 rounded-2xl shadow-sm border border-gray-200/60 p-3.5 transition-all duration-200 hover:bg-white/80 hover:shadow-md backdrop-blur-sm">
      <div className="flex justify-between items-start mb-2">
        <h2 className='text-base font-semibold text-gray-900'>{title}</h2>
        <AiOutlineInfoCircle className="text-gray-600 text-base cursor-pointer hover:text-gray-800 transition-colors flex-shrink-0" />
      </div>

      <p className="text-sm text-gray-600 mb-3">{detailed_label}</p>

      <div>
        <label htmlFor={name} className="block mb-1.5 text-xs font-medium text-gray-700">
          {effectiveLabel}
        </label>
        <input
          id={name}
          type="number"
          value={displayValue}
          onChange={handleChange}
          className="bg-white/80 border border-gray-300 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-gray-400 focus:border-gray-400 hover:border-gray-400 block w-full p-2.5 placeholder-gray-400 transition-all duration-200 shadow-sm"
          placeholder={field?.placeholder || label}
          step={conversionFactor !== 1 ? "0.1" : "1"}
        />
        {/* Hidden input for form registration */}
        <input
          type="hidden"
          {...register(name, validation)}
          value={displayToBackend(displayValue)}
        />
        <ErrorBox errors={errors} />
      </div>
    </div>
  );
};

export default SingleDimensionPicker;
